module.exports = __webpack_public_path__ + "static/img/device-error-marker.13d02e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/device-error-marker.png
// module id = qKGS
// module chunks = 28